import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AXIS_TICKS, GRID_COLOUR, TOOLTIP } from '../dashboard/chartTheme';
import { formatActive, formatCount, hasProgressData } from './format';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Tooltip,
  Legend
);

const SERIES = [
  { key: 'enrolled', label: 'Enrolled', colour: '#D1D5DB' },
  { key: 'active', label: 'Active', colour: '#00999E' },
  { key: 'graduated', label: 'Graduated', colour: '#8B173B' },
];

// Enrolled, active and graduated per year (by the year each cohort started).
// Suppressed or missing values draw no bar; the tooltip says why.
function YearOnYearChart({ years, withoutProgress, onSelectYear }) {
  const data = {
    labels: years.map((year) => String(year.year)),
    datasets: SERIES.map((series) => ({
      label: series.label,
      data: years.map((year) => year[series.key] ?? null),
      backgroundColor: series.colour,
      borderRadius: 3,
      maxBarThickness: 28,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    onClick: (_event, elements) => {
      if (elements.length && onSelectYear) {
        onSelectYear(years[elements[0].index].year);
      }
    },
    onHover: (event, elements) => {
      // eslint-disable-next-line no-param-reassign
      event.native.target.style.cursor = elements.length
        ? 'pointer'
        : 'default';
    },
    scales: {
      x: { grid: { display: false }, ticks: AXIS_TICKS },
      y: {
        beginAtZero: true,
        grid: { color: GRID_COLOUR, drawBorder: false },
        ticks: AXIS_TICKS,
        title: { display: true, text: 'Learners', ...AXIS_TICKS },
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 10, boxHeight: 10, padding: 16, ...AXIS_TICKS },
      },
      tooltip: {
        ...TOOLTIP,
        callbacks: {
          label: (item) => {
            const year = years[item.dataIndex];
            const { key, label } = SERIES[item.datasetIndex];
            const value =
              key === 'active'
                ? formatActive(year, hasProgressData(year, withoutProgress))
                : formatCount(year[key]);
            return ` ${label}: ${value}`;
          },
        },
      },
    },
  };

  return (
    <div className="h-80">
      <Bar data={data} options={options} />
    </div>
  );
}

export default YearOnYearChart;
